module.exports = __webpack_public_path__ + "static/media/messages.98863831.svg";